module.exports = __webpack_public_path__ + "static/images/trending-up-blue.a4fda35b5034b72e6b553683938517fa.svg";